module.exports = __webpack_public_path__ + "imgascvts/Book.194cf968.png";